export default __webpack_public_path__ + "static/media/g-normal.5b01d118.svg";